import { Component, OnInit, Input } from '@angular/core';

export type NcDirectionType = 'horizontal' | 'vertical';

@Component({
  selector: 'nc-animated-gradient-text',
  templateUrl: './animated-gradient-text.component.html',
  styleUrls: ['./animated-gradient-text.component.less']
})
export class AnimatedGradientTextComponent implements OnInit {
  /** 文本内容 */
  @Input() ncText: string = '';
  /** 动画速度，值越大，动画速度越快 */
  @Input() ncSpeed: number = 1;
  /** 渐变颜色数组 */
  @Input() ncColors: string[] = ['#ffaa40', '#9c40ff'];
  /** 渐变方向 */
  @Input() ncDirection: NcDirectionType = 'horizontal';

  constructor() { }

  ngOnInit(): void {
  }

  get gradientColors(): string {
    if (!this.ncColors || this.ncColors.length <= 1) {
      return '#ffaa40, #9c40ff, #ffaa40';
    }
    // 将数组展开，最后一项添加第一项以形成循环
    return [...this.ncColors, this.ncColors[0]].join(', ');
  }
}
